<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">{{data.content}}</div>
    <div mat-dialog-actions class="dialog-actions mt-4 text-right">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button *ngIf="!isLoading; else deleteLoadingTemplate" (click)="deleteEmployee()"
            class="delete-button" cdkFocusInitial>{{data.confirmText}}</button>
        <ng-template #deleteLoadingTemplate>
            <button mat-button class="delete-button" disabled>
                {{data.confirmText}} <span class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>